"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "buttrio": {
    "d407cdd3": [{
      "hkey": "08b576e3",
      "slug": "buttrio",
      "name": "Buttrio",
      "primary": true,
      "skipSearch": false
    }],
    "caminetto": [{
      "hkey": "08b576e3",
      "slug": "buttrio",
      "name": "Buttrio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5bf1e66d": [{
      "hkey": "08b576e3",
      "slug": "buttrio",
      "name": "Buttrio",
      "primary": true,
      "skipSearch": false
    }],
    "camino": [{
      "hkey": "08b576e3",
      "slug": "buttrio",
      "name": "Buttrio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aef96259": [{
      "hkey": "08b576e3",
      "slug": "buttrio",
      "name": "Buttrio",
      "primary": true,
      "skipSearch": false
    }],
    "vicinale": [{
      "hkey": "08b576e3",
      "slug": "buttrio",
      "name": "Buttrio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;